import { checkPermission } from "@ROM/Permissions/utils";

export const canSeeWarehouseInventories = (user) => checkPermission(user, "warehouse-inventories:index");
export const canUpdateWarehouseInventories = (user) => checkPermission(user, "warehouse-inventories:update");
